import { ReturningMemberInfo } from '../../../auth/components/returning-member/ReturningMemberInfo';

export default function ReturningMemberInfoPage() {
    return <ReturningMemberInfo />;
}
